import {
  corporateHealthOrderUserRemainingBenefitsFetch,
  CorporateHealthOrderUserRemainingBenefitsFetchPayload,
} from '@components/CorporateHealthQuoteBuyRoute/action';
import React, { useEffect, useState } from 'react';
import { Container, Button, Modal, ModalProps, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { map, isUndefined, isEmpty } from 'lodash';
import { CorporateUser } from '@models/User';
import { BenefitTableRow } from './benefit-table-row';

import { selectCorporateHealthQuoteBuy } from '../../selector';
import { Loading, NoData } from '@components/Base';

type Props = ModalProps & {
  id: number;
  user: CorporateUser;
};

const UserBenefitScheduleModal = ({ show, onHide, id, user }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const { corporateHealthOrderUserRemainingBenefits } = useSelector(selectCorporateHealthQuoteBuy);
  const hasRemainingBenefits = !isEmpty(corporateHealthOrderUserRemainingBenefits);

  useEffect(() => {
    setIsLoading(true);
    const payload: CorporateHealthOrderUserRemainingBenefitsFetchPayload = {
      id,
      username: user.username,
    };
    dispatch(corporateHealthOrderUserRemainingBenefitsFetch(payload));
  }, [id, user]);

  useEffect(() => {
    if (isUndefined(corporateHealthOrderUserRemainingBenefits)) return;
    setIsLoading(false);
  }, [corporateHealthOrderUserRemainingBenefits]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('common:benefitSchedule')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="mt-4">
          {isLoading ? (
            <Loading />
          ) : (
            <Table>
              <thead>
                <tr>
                  <th>{t('common:benefit')}</th>
                  <th>{t('common:description')}</th>
                  <th>{t('common:limitAmount')}</th>
                  <th>{t('common:remainingLimitAmount')}</th>
                </tr>
              </thead>
              <tbody>
                {!hasRemainingBenefits ? (
                  <tr>
                    <td colSpan={4} className="text-center">
                      <NoData />
                    </td>
                  </tr>
                ) : (
                  map(corporateHealthOrderUserRemainingBenefits, (benefit) => {
                    return (
                      <BenefitTableRow key={`${benefit.id}-${benefit.healthPlanBenefit.benefitType}`} {...benefit} />
                    );
                  })
                )}
              </tbody>
            </Table>
          )}
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} variant="primary">
          {t('common:close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { UserBenefitScheduleModal };
